import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
        name: 'sortByField'
      })
export class SortByFieldPipe implements PipeTransform {

  transform<T>(value: T[], fieldName: string, fieldValuesOrdered: string[]): T[] {
    return value.sort((n1, n2) => fieldValuesOrdered.indexOf(n1[fieldName]) - fieldValuesOrdered.indexOf(n2[fieldName]));
  }
}
